<template>
  <div>
    <b-table
      :busy="loading"
      hover
      :items="registros ? registros.data : null"
      :fields="fields"
      @row-dblclicked="ver"
      show-empty
    >
      <template #cell(scenario)="data">
        <VerRegistro
          :row="data"
          :opcionVer="opcionVer"
          @ver="$emit('ver', data.item)"
        >
          <alert-sin-asignar
            :icon="true"
            variant="danger"
            text="Sin asignar"
            v-if="!data.value.name"
          ></alert-sin-asignar>
          {{ data.value.name }}
        </VerRegistro>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <OverlayButton clase="overlay-md"></OverlayButton>
        </div>
      </template>
    </b-table>

    <Pagination
      :data="registros ? registros : null"
      :limit="limit"
      @pagination-change-page="eventoPaginar"
      align="center"
    >
      <template #prev-nav>
        <span>&lt;</span>
      </template>
      <template #next-nav>
        <span>&gt;</span>
      </template>
    </Pagination>
  </div>
</template>


<script>
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
import VerRegistro from "@/components/datatables/VerRegistro.vue";
import AlertSinAsignar from "@/components/core/alert/alert-sin-asignar.vue";
export default {
  name: "tips-point-sale-table",
  components: {
    OverlayButton,
    Pagination,
    VerRegistro,
    AlertSinAsignar,
  },
  emits: ["paginar", "ver"],
  data() {
    return {
      limit: 10,
      fields: [
        {
          label: "Punto de Venta",
          key: "name",
          sortable: true,
        },
        {
          label: "Código",
          key: "code",
          formatter: "names_sub_scenarios",
          sortable: true,
        },
        {
          label: "Escenario",
          key: "scenario",
          sortable: true,
        },
      ],
    };
  },
  props: {
    parametros: { type: Object, default: null },
    registros: {
      type: Object,
      default() {
        return { data: null, meta: null, links: null };
      },
    },
    opcionVer: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ver(item /*index, event*/) {
      this.$emit("ver", item);
    },
    eventoPaginar(page = 1) {
      this.$emit("paginar", page);
    },
  },
};
</script>

<style>
</style>